module.exports = __webpack_public_path__ + "static/img/pc_logo.521c83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/developerConference/pc_logo.png
// module id = SBOR
// module chunks = 86